module.exports = __webpack_public_path__ + "static/media/12.6b5fc8d2.jpg";